// extracted by mini-css-extract-plugin
module.exports = {"jds-CardAside":"cardAside_jds-CardAside__El0Ez","jds-CardAside--hasPadding":"cardAside_jds-CardAside--hasPadding__bndIs"};